import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	dashboard: [],
};

// active account slice
export const dashboardSlice = createSlice({
	name: 'dashboard',
	initialState,
	reducers: {
		setAllDashboardCount: (state, action) => {
			state.dashboardCount = action.payload;
		},
		setAllDashboardPostsCount: (state, action) => {
			state.dashboardPostsCount = action.payload;
		},
	},
});

export const {
	setAllDashboardCount,
	setAllDashboardPostsCount,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
